var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a",
    {
      staticClass: "card card-horizontal card-outer card-callout",
      attrs: { href: _vm.item.Url }
    },
    [
      _vm.item.SquareImage
        ? _c("div", {
            staticClass: "card-img",
            style: { backgroundImage: "url(" + _vm.item.SquareImage + ")" }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "card-content" }, [
        _c("span", { staticClass: "icon icon-arrow-right asdf" }),
        _vm._v(" "),
        _c("p", { staticClass: "meta" }, [
          _vm._v(
            _vm._s(_vm.formatDate(_vm.item.Date)) +
              " | " +
              _vm._s(_vm.item.AuthorName)
          )
        ]),
        _vm._v(" "),
        _vm.item.Title ? _c("h2", [_vm._v(_vm._s(_vm.item.Title))]) : _vm._e(),
        _vm._v(" "),
        _vm.item.Summary
          ? _c("p", [
              _vm._v(_vm._s(_vm.item.Summary) + " "),
              _c("span", { staticClass: "cta-link" }, [_vm._v("Read More")])
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.item.Tags
          ? _c("div", { staticClass: "card-tags" }, [
              _c("span", [_vm._v("Topics:")]),
              _vm._v(" "),
              _c(
                "ul",
                _vm._l(_vm.item.Tags, function(tag) {
                  return _c("li", [_vm._v(_vm._s(tag.Text))])
                }),
                0
              )
            ])
          : _vm._e()
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }